import axios from '../api';

export default {
  namespaced: true,

  state: {
    personalLibrary: true, //Détermine dans quel bibliothèque l'utilisateur se trouve

  },

  getters: {

    idJob(state){
      return state.idJob;
    },

    formContent(state){
      return state.formContent;
    },

    loading(state){
      return state.loading;
    },

    messageHeader(state){
      return state.messageHeader;
    },



    personalLibrary(state){
      return state.personalLibrary;
    }
  },

  mutations: {

    SET_LISTMODULESPAGES(state, modules){
      state.listModulesPages = modules;
    },
    SET_IDJOB(state, infos){
      state.idJob = infos;
    },
    SET_FORMCONTENT(state, contents){
      state.formContent = contents;
    },
    SET_LOADING(state, loadornot){
      state.loading = loadornot;
    },
    SET_MESSAGEHEADER(state, progress){
      state.messageHeader = progress;
    },

    SET_PERSONALLIBRARY(state, bool){
      state.personalLibrary = bool;
    }
  },
  actions: {
    async save_datas(context) {
      //var infosJob = context.getters.infosJob;
      let id_job = context.getters.idJob;
      let form = context.getters.formContent;

      await axios.put('/api/job_description/'+id_job, {data: form}).then(() => {
        context.commit('SET_MESSAGEHEADER', 'saveIsSuccess');
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', '');}, 3000);
      })
        .catch(error => {
          context.commit('SET_MESSAGEHEADER', 'error');
          setTimeout(() => {context.commit('SET_MESSAGEHEADER', '');}, 3000);
          console.log('ERRRR:: ',error.response.data);
        });
    },
  }
};
